/* src/components/common/Modal.jsx */
import React from 'react'
import '../../css/modal.css'

const Modal = ({ open, onClose, children }) => {
  if (!open) return null                // niente DOM se non serve
  return (
    <div className="rr-modal-back" onClick={onClose}>
      <div className="rr-modal-body" onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>
  )
}

export default Modal
